import { FC } from 'react';
import { GridRowsProp, GridColumns, DataGrid, GridCellParams } from '@material-ui/data-grid';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import PostAddIcon from '@material-ui/icons/PostAdd';
import DeleteIcon from '@material-ui/icons/Delete';

const rows: GridRowsProp = [
  {
    id: 1,
    name: '[ACL Assignment]',
    desc: 'example in MyOrg',
  },
  {
    id: 2,
    name: '[ACL Assignment]',
    desc: 'example in MyOrg',
  },
  {
    id: 3,
    name: '[ACL Assignment]',
    desc: 'example in MyOrg',
  },
];

export const ACLAssignmentsTable: FC = () => {
  const columns: GridColumns = [
    {
      field: 'icon',
      headerName: ' ',
      width: 50,
      renderCell: (params: GridCellParams) => <PostAddIcon />,
    },
    { field: 'name', headerName: 'NAME', width: 250 },
    { field: 'desc', headerName: 'DESCRIPTION', flex: 1 },
    {
      field: 'actions',
      headerName: 'ACTIONS',
      width: 160,
      renderCell: (params: GridCellParams) => (
        <>
          <IconButton>
            <EditIcon style={{ fill: '#FF9800' }} />
          </IconButton>
          <IconButton>
            <DeleteIcon style={{ fill: '#F44336' }} />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <>
      <DataGrid autoHeight rows={rows} columns={columns} checkboxSelection />
    </>
  );
};
